import { render } from "./CollapseButton.vue?vue&type=template&id=2d341e2b"
import script from "./CollapseButton.vue?vue&type=script&lang=js"
export * from "./CollapseButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CollapseButton.vue"]])

export default __exports__